import { isPracticeMode } from '../services/commitAdapter';
import styles from './PracticeRibbon.module.css';

/**
 * "Practice mode — nothing is saved", across the top of the shell whenever the dry-run writer is
 * active (13-08). It reads the same flag `getWriter()` does, so the ribbon and the writer can
 * never disagree. Production turns it off only at 13-13 (`VITE_QMS_LIVE_WRITES=true`).
 */
export default function PracticeRibbon() {
  if (!isPracticeMode()) return null;
  return (
    <div className={styles.ribbon} role="note" aria-label="Practice mode">
      <span className={styles.mark} aria-hidden="true" />
      <strong className={styles.title}>Practice mode — nothing is saved</strong>
      <span className={styles.detail}>Try anything. Nothing you do here is written to SharePoint.</span>
    </div>
  );
}
